import { uiText } from './text.js';

/**
 * The bag's « Ranger » button, beside its heading. It only asks: the server
 * decides the order (`sortBag`) and sends the bag back like after any change.
 */
export class BagSortButton {
  readonly element: HTMLButtonElement;

  constructor(onSort: () => void) {
    this.element = document.createElement('button');
    this.element.type = 'button';
    this.element.className = 'bag-sort';
    this.element.textContent = uiText('Ranger');
    this.element.title = uiText('Ranger le sac : équipement, consommables, puis matériaux');
    this.element.addEventListener('click', () => {
      if (!this.element.disabled) onSort();
    });
  }

  /**
   * Greyed while another window takes from the bag (trade, auction): their
   * picks name the rows a merge could empty. Nothing to tidy in an empty bag.
   */
  update(state: { picking: boolean; empty: boolean }): void {
    this.element.disabled = state.picking || state.empty;
  }
}
